import i18n from '../../../i18n';

let constraints = {};

i18n.on('initialized', () => {
  constraints = {
    courseReviewDate: {
     type:"date"
    },
  };
});

export default function () {
  return constraints;
};
